import { IChatDeleteAction } from './types';
import { AT_CHAT_DELETE } from './constants';
import { IChat } from 'app/rest/effects/chats/chat/types';

export const chatDeleteAction = (
    chat: IChat
): IChatDeleteAction => ({
    type: AT_CHAT_DELETE,
    chat,
});
